module.exports = __webpack_public_path__ + "img/p_beam.25bff00c.jpg";